<template>
  <div id="app">
    <router-view/>
    <ejs-sidebar ref="blockSidebar" class="block-sidebar" :width="'100%'" :type="'Over'" :position="'Right'"
                 :created="createdSidebar" :enableGestures="false" :close="onSidebarClosed">
      <div class="sidebar-header" ref="headerSidebar">
        <div class="content-sidebar-header">
          <h2 class="title-sidebar-header">{{ sidebar.title }} </h2>
          <h2 class="action-sidebar-header"><i v-on:click="closeSidebarClick">X</i></h2>
        </div>
      </div>
      <div class="sidebar-body">
        <component v-bind:is="sidebar.currentTabComponent" :data="sidebar.data"></component>
      </div>
    </ejs-sidebar>
    <ejs-toast ref='toastNotification' title="NOTIFICACIÓN" content=""
               :class="'e-toast-container e-toast-top-right e-toast-'+classToastNotification"
               :position="{ X: 'Right', Y: 'Top' }" timeOut=5000></ejs-toast>
  </div>
</template>
<script>
import {createSpinner, showSpinner, hideSpinner} from '@syncfusion/ej2-popups';
import {loadCldr, L10n, setCulture} from '@syncfusion/ej2-base';
import hubspotChat from '@src/services/hubspot-chat';

loadCldr(
    require('cldr-data/supplemental/numberingSystems.json'),
    require('cldr-data/main/es-CO/ca-gregorian.json'),
    require('cldr-data/main/es-CO/numbers.json'),
    require('cldr-data/main/es-CO/timeZoneNames.json')
);

L10n.load({
  'es-CO': {
    'schedule': {
      'today': 'Hoy',
      'noEvents': 'No hay eventos',
    },
    'pager': {
      'currentPageInfo': '{0} de {1} páginas',
      'totalItemsInfo': '({0} Registros)',
    },
    'grid': {
      'EmptyRecord': 'No hay registros para mostrar',
      'EmptyDataSourceError': 'No hay registros para mostrar',
      'GroupDropArea': 'Arrastra una columna aquí para agrupar',
      'UnGroup': 'Haz clic aquí para desagrupar',
      'Item': 'elemento',
      'Items': 'elementos',
      'FilterButton': 'Filtrar',
      'ClearButton': 'Limpiar',
      'StartsWith': 'Empieza con',
      'EndsWith': 'Termina con',
      'Contains': 'Contiene',
      'Equal': 'Igual',
      'NotEqual': 'Distinto',
      'LessThan': 'Menor que',
      'LessThanOrEqual': 'Menor o igual que',
      'GreaterThan': 'Mayor que',
      'GreaterThanOrEqual': 'Mayor o igual que',
      'ChooseDate': 'Selecciona una fecha',
      'EnterValue': 'Introduce un valor',
      'MatchCase': 'Coincidir mayúsculas/minúsculas',
      'Between': 'Entre',
      'CustomFilter': 'Filtro personalizado',
      'SelectAll': 'Seleccionar todo',
      'Blanks': 'Vacíos',
      'FilterTrue': 'Verdadero',
      'FilterFalse': 'Falso',
      'OKButton': 'Aceptar',
      'CancelButton': 'Cancelar',
      'Search': 'Buscar',
      'NoResult': 'Sin coincidencias',
      'ClearFilter': 'Quitar filtro',
      'SortAscending': 'Orden ascendente',
      'SortDescending': 'Orden descendente',
      'EditFormTitle': 'Detalles de',
      'AddFormTitle': 'Agregar nuevo registro',
      'SaveButton': 'Guardar',
      'EditOperationAlert': 'Selecciona un registro para editar',
      'DeleteOperationAlert': 'Selecciona un registro para eliminar',
      'AddOperationAlert': 'Selecciona un registro para agregar',
      'ConfirmDelete': '¿Estás seguro de que deseas eliminar este registro?',
      'CancelEdit': '¿Estás seguro de cancelar los cambios?',
      'PagerInfo': '{0} de {1} páginas ({2} registros)',
    },
    'uploader': {
      'Browse': 'Examinar',
      'Clear': 'Claro',
      'Upload': 'Subir',
      'dropFilesHint': 'o suelta archivos aquí',
      'uploadFailedMessage': 'Error al cargar el archivo',
      'uploadSuccessMessage': 'Archivo cargado con éxito',
      'removedSuccessMessage': 'Archivo eliminado con éxito',
      'removedFailedMessage': 'Error al eliminar el archivo',
      'inProgress': 'Cargando',
      'pauseUpload': 'Pausa de carga',
      'fileUploadCancel': 'Cancelar carga de archivo',
      'readyToUploadMessage': 'Listo para cargar',
      'invalidMaxFileSize': 'Tamaño de archivo excedido',
      'invalidFileType': 'Tipo de archivo no permitido',
      'invalidMinFileSize': 'Tamaño de archivo insuficiente',
      'remove': 'Eliminar',
      'cancel': 'Cancelar',
      'delete': 'Eliminar',
      'totalFiles': 'Total de archivos',
      'size': 'Tamaño',
    },
    'dropdowns': {
      'noRecordsTemplate': 'No se encontraron registros',
      'actionFailureTemplate': 'Error al cargar los datos',
      'overflowCountTemplate': '+${count} más...',
      'selectAllText': 'Seleccionar todo',
      'unSelectAllText': 'Deseleccionar todo'
    },
    'datepicker': {
      'placeholder': 'Selecciona una fecha',
      'today': 'Hoy'
    },
    'datetimepicker': {
      'placeholder': 'Selecciona fecha y hora',
      'today': 'Hoy'
    },
    'numerictextbox': {
      'incrementTitle': 'Incrementar valor',
      'decrementTitle': 'Disminuir valor'
    },
    'textbox': {
      'placeholder': 'Introduce texto'
    },
    'filter': {
      'StartsWith': 'Empieza con',
      'EndsWith': 'Termina con',
      'Contains': 'Contiene',
      'Equal': 'Igual',
      'NotEqual': 'Distinto',
      'LessThan': 'Menor que',
      'LessThanOrEqual': 'Menor o igual que',
      'GreaterThan': 'Mayor que',
      'GreaterThanOrEqual': 'Mayor o igual que',
      'SelectField': 'Selecciona campo',
      'SelectOperator': 'Selecciona operador',
      'EnterValue': 'Introduce valor',
      'AND': 'Y',
      'OR': 'O',
      'OK': 'Aceptar',
      'Cancel': 'Cancelar',
    },
    'excelFilter': {
      'CustomFilter': 'Filtro personalizado',
      'Equals': 'Igual',
      'DoesNotEqual': 'Distinto',
      'GreaterThan': 'Mayor que',
      'GreaterThanOrEqual': 'Mayor o igual que',
      'LessThan': 'Menor que',
      'LessThanOrEqual': 'Menor o igual que',
      'BeginsWith': 'Empieza con',
      'EndsWith': 'Termina con',
      'Contains': 'Contiene',
      'DoesNotContain': 'No contiene',
      'EnterValue': 'Introduce valor',
      'AND': 'Y',
      'OR': 'O',
      'OK': 'Aceptar',
      'Cancel': 'Cancelar',
    }
  }
});

setCulture('es-CO');

export default {
  name: 'app',
  data() {
    return {
      classToastNotification: '',
      sidebar: {
        data: [],
        title: '',
        currentTabComponent: ''
      },
      isClosingSideBar: false,
    }
  },
  computed: {
    isAuthenticated: function () {
      const avatar = this.$store.getters['moduleAvatar/avatar'];
      return !!(avatar && avatar.email);
    }
  },
  watch: {
    // Reaccionar al ciclo de vida de autenticación (login / logout).
    isAuthenticated: function (loggedIn, wasLoggedIn) {
      if (loggedIn && !wasLoggedIn) {
        // Login en caliente: identificar y recargar el widget.
        hubspotChat.identify();
      } else if (!loggedIn && wasLoggedIn) {
        // Logout: limpiar la identificación y resetear el chat.
        hubspotChat.reset();
      }
    }
  },
  mounted: function () {
    createSpinner({
      target: document.getElementById('app')
    })
    // Inicializar el chat de HubSpot (invitado o autenticado) una sola vez.
    hubspotChat.init(this.isAuthenticated);
  },
  methods: {
    createdSidebar: function () {
      this.$refs.blockSidebar.hide();
    },
    closeSidebarClick: function () {
      this.$refs.blockSidebar.hide();
      this.sidebar.currentTabComponent = '';
    },
    onShowSpinner: function () {
      showSpinner(document.getElementById('app'));
      $('.e-spinner-pane').removeClass('e-spin-hide').addClass('e-spin-show');
    },
    onHideSpinner: function () {
      $('.e-spinner-pane').removeClass('e-spin-show').addClass('e-spin-hide');
    },
    unacceptedTerms: function (response){
      this.$store.dispatch('moduleTerms/updateHasAcceptedTerms', false);
      this.$router.push({name: 'terms'});
    },
    showToastNotification: function (response) {
      let message = response.message;
      this.classToastNotification = response.status;
      this.$refs.toastNotification.ej2Instances.content = message;
      this.$refs.toastNotification.show();
    },
    showExpiredSession: function () {
      this.onHideSpinner();
      this.closeSidebarClick();
      document.getElementById("expired").ej2_instances[0].show();
    },
    onSidebarClosed: function () {
      this.isClosingSideBar = false;
    },
  },
  created() {
    this.$eventHub.$on('onShowSpinner', this.onShowSpinner);
    this.$eventHub.$on('onHideSpinner', this.onHideSpinner);
    this.$eventHub.$on('closeSidebarClick', this.closeSidebarClick);
    this.$eventHub.$on('showExpiredSession', this.showExpiredSession);
    this.$eventHub.$on('toggleSidebarClick', (title, component, data = false, addClass = false, addHeaderClass = false) => {
      const waitForSidebarToClose = () => {
        if (!this.isClosingSideBar) {
          this.sidebar.data = data;
          this.sidebar.title = title;
          this.sidebar.currentTabComponent = component;
          this.$refs.blockSidebar.show();
          this.$refs.blockSidebar.$el.classList.remove('mw-100');
          this.$refs.headerSidebar.classList.remove('sidebar-header-without-text');
          if (addClass) this.$refs.blockSidebar.$el.classList.add(addClass);
          if (addHeaderClass) this.$refs.headerSidebar.classList.add(addHeaderClass);

          clearInterval(checkSidebarInterval); 
        }
      };
      const checkSidebarInterval = setInterval(waitForSidebarToClose, 100);
    });
    this.$eventHub.$on('showToastNotification', this.showToastNotification);
    this.$eventHub.$on('unacceptedTerms', this.unacceptedTerms);
  }
}
</script>
<style scoped>
  .content-sidebar-header{
    display: flex !important;
    justify-content: space-between !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1) !important;
  }
  .title-sidebar-header{
    display: block !important;
    width: 90% !important; 
    overflow: hidden !important; 
    text-overflow: ellipsis !important; 
    white-space:nowrap;
    border-bottom: 0 !important; 
    padding-bottom: 0 !important;
  }
  .action-sidebar-header{
    border-bottom: 0 !important; 
    padding-bottom: 0 !important;
  }
</style>